import { render } from "./OrderJournal.vue?vue&type=template&id=9a40c3c6&scoped=true"
import script from "./OrderJournal.vue?vue&type=script&lang=js"
export * from "./OrderJournal.vue?vue&type=script&lang=js"

import "./OrderJournal.vue?vue&type=style&index=0&id=9a40c3c6&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a40c3c6"]])

export default __exports__